import style from '../style/Report.module.scss';
import {Link} from "react-router-dom";
import className from 'classnames/bind';
import ActionBar from "~/layout/ActionBar";
import Icon from "~/components/Icon";
import {useCan} from "~/hooks";
const cn = className.bind(style);

function Report() {
	const can = {
		'saleAnalytic': useCan('reportSaleAnalytic'),
		'salePoint': useCan('reportSalePoint'),
		'callSource': useCan('salesCallSourceView'),
		'staffSummary': useCan('reportSaleStaffSummary'),
		'sale': useCan('reportSale'),
		'commit': useCan('reportSaleCommit'),
		'revenue': useCan('reportRevenue'),
		'extend': useCan('reportExtend'),
		'pay': useCan('reportPay'),
		'financial': useCan('reportFinancial'),
		'cashFlow': useCan('reportCashFlow'),
		'debt': useCan('reportDebt'),
		'website': useCan('reportContract'),
		'training': useCan('reportTraining'),
	}
	/*Sale: Điểm tư vấn*/
	const ItemSalePoint = () => {
		if(!can.salePoint) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/point'}>
					<h3 className={'text-lg'}>Điểm tư vấn</h3>
					<p>Thống kê điểm làm việc hằng ngày</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: Lịch hẹn*/
	const ItemSaleEvent = () => {
		if(!can.salePoint) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/event'}>
					<h3 className={'text-lg'}>Lịch hẹn & tư vấn</h3>
					<p>Thống kê báo cáo cuộc hẹn, tư vấn</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: Gọi điện tìm nguồn*/
	const ItemSaleCallSource = () => {
		if(!can.callSource) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.search}</div>
			<div className={cn('info')}>
				<Link to={'sales/call-source'}>
					<h3 className={'text-lg'}>Gọi điện tìm nguồn</h3>
					<p>Thống kê nguồn tìm được & cuộc gọi của nhân viên</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: Tổng hợp đánh giá nhân viên kinh doanh*/
	const ItemSaleStaffSummary = () => {
		if(!can.staffSummary) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/staff-summary'}>
					<h3 className={'text-lg'}>Đánh giá nhân viên kinh doanh</h3>
					<p>Tổng hợp nguồn, cuộc gọi, hẹn, tư vấn, hợp đồng & doanh thu</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: cam kết*/
	const ItemSaleCommit = () => {
		if(!can.commit) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/commit'}>
					<h3 className={'text-lg'}>Cam kết</h3>
					<p>Thống kê báo cáo cam kết</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Doanh thu*/
	const ItemRevenue = () => {
		if(!can.revenue) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.dola}</div>
			<div className={cn('info')}>
				<Link to={'revenue'}>
					<h3 className={'text-lg'}>Doanh thu</h3>
					<p>Báo cáo doanh thu công ty</p>
				</Link>
			</div>
		</div>)
	}
	/*Extend: Gia hạn*/
	const ItemExtend = () => {
		if(!can.extend) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.dola}</div>
			<div className={cn('info')}>
				<Link to={'extend'}>
					<h3 className={'text-lg'}>Gia hạn</h3>
					<p>Báo cáo doanh số gia hạn (tổng kết, theo người, theo dịch vụ)</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Lương*/
	const ItemPay = () => {
		if(!can.pay) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'pay'}>
					<h3 className={'text-lg'}>Lương</h3>
					<p>Báo cáo lương từng phòng ban</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Điểm*/
	const ItemPoint = () => {
		if(!can.pay) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'point'}>
					<h3 className={'text-lg'}>Điểm</h3>
					<p>Báo cáo điểm từng nhân viên</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Báo cáo tài chính tổng hợp*/
	const ItemFinancialSummary = () => {
		if(!can.financial) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.dola}</div>
			<div className={cn('info')}>
				<Link to={'financial-summary'}>
					<h3 className={'text-lg'}>Báo cáo tài chính</h3>
					<p>Tổng hợp doanh thu & chi phí theo công ty</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Báo cáo dòng tiền*/
	const ItemCashFlow = () => {
		if(!can.cashFlow) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'cash-flow'}>
					<h3 className={'text-lg'}>Dòng tiền</h3>
					<p>Số dư & thu chi theo từng tài khoản</p>
				</Link>
			</div>
		</div>)
	}
	/*Service: Website*/
	const ItemWebsite = () => {
		if(!can.website) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'website'}>
					<h3 className={'text-lg'}>Hợp đồng</h3>
					<p>Báo cáo hợp đồng theo nhân viên & loại hợp đồng</p>
				</Link>
			</div>
		</div>)
	}
	//Công nợ
	const ItemDebt = () => {
		if(!can.debt) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'debt'}>
					<h3 className={'text-lg'}>Công nợ</h3>
					<p>Danh sách dịch vụ chưa thanh toán</p>
				</Link>
			</div>
		</div>)
	}


	//đào tạo
	const ItemTraining = () => {
		if(!can.training) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'training'}>
					<h3 className={'text-lg'}>Đào tạo</h3>
					<p>Báo cáo thống kê lịch đào tạo</p>
				</Link>
			</div>
		</div>)
	}

	return (
		<>
			<ActionBar title={'Báo cáo'}></ActionBar>
			<div className="container" style={{display: 'block'}}>
				<div className="content">
					<div className={cn('items', 'gap-1')}>
						<ItemSaleEvent />
						<ItemSaleCallSource />
						<ItemSaleStaffSummary />
						<ItemSaleCommit />
						<ItemSalePoint />
						<ItemPoint />

						<ItemTraining />
						<ItemWebsite />
						<ItemDebt />

						<ItemRevenue />
						<ItemExtend />
						<ItemPay />
						<ItemFinancialSummary />
						<ItemCashFlow />
					</div>
				</div>
			</div>
		</>
	)
}

export default Report;